import joi from "joi";
import { DESCRIPTION_JOI_VALIDATOR_MESSAGES, DESCRIPTION_VALIDATOR, EMAIL_JOI_VALIDATOR_MESSAGES, LINKS_JOI_VALIDATOR_MESSAGES, ORGANIZATION_DISPLAY_NAME_JOI_VALIDATOR_MESSAGES, ORGANIZATION_DISPLAY_NAME_VALIDATOR, ORGANIZATION_DOMAIN_VALIDATOR, ORGANIZATION_NAME_JOI_VALIDATOR_MESSAGES, ORGANIZATION_NAME_VALIDATOR } from "../../validation.js";
const displayNameValidation = joi.string().max(ORGANIZATION_DISPLAY_NAME_VALIDATOR.maxLength.value).min(ORGANIZATION_DISPLAY_NAME_VALIDATOR.minLength.value).pattern(ORGANIZATION_DISPLAY_NAME_VALIDATOR.pattern.value).required().messages(ORGANIZATION_DISPLAY_NAME_JOI_VALIDATOR_MESSAGES);
const nameValidation = joi.string().max(ORGANIZATION_NAME_VALIDATOR.maxLength.value).min(ORGANIZATION_NAME_VALIDATOR.minLength.value).pattern(ORGANIZATION_NAME_VALIDATOR.pattern.value).required().messages(ORGANIZATION_NAME_JOI_VALIDATOR_MESSAGES);
const emailValidation = joi.string().email({
    tlds: false
}).messages(EMAIL_JOI_VALIDATOR_MESSAGES).required();
const inviteMemberBaseSchema = joi.object({
    name: displayNameValidation,
    email: emailValidation
});
const optionalEmailValidation = joi.string().email({
    tlds: false
}).optional().messages(EMAIL_JOI_VALIDATOR_MESSAGES).allow('');
const emptyStringValidation = joi.string().optional().allow('');
const descriptionValidation = joi.string().optional().max(DESCRIPTION_VALIDATOR.maxLength.value).pattern(DESCRIPTION_VALIDATOR.pattern.value).messages(DESCRIPTION_JOI_VALIDATOR_MESSAGES).allow(null, '');
const socialAccountsValidation = joi.array().items(joi.object({
    label: emptyStringValidation,
    link: emptyStringValidation
})).max(5).required().default([]);
const socialAccountsFormValidation = joi.array().items(joi.object({
    link: joi.string().uri().messages(LINKS_JOI_VALIDATOR_MESSAGES).optional().allow(null, ''),
    label: joi.string().uri().messages(LINKS_JOI_VALIDATOR_MESSAGES).optional().allow(null, '')
})).max(5).required().default([]);
const privacyOptionsValidation = joi.object({
    isPrivate: joi.boolean().required()
}).required();
const locationValidation = joi.string().required().max(100).allow('').default('');
const locationOptionsValidation = joi.object({
    location: locationValidation,
    locationVisible: joi.boolean().required().default(true)
}).required();
const CONFIRM_WORD = 'delete';
const orgSettingsDeleteForm = (orgName)=>joi.object({
        name: joi.string().required().valid(orgName).messages({
            'any.only': "You must input the full organization name"
        }),
        confirm: joi.string().required().valid(CONFIRM_WORD).messages({
            'any.only': "you must type in '".concat(CONFIRM_WORD, "' to take complete this action")
        })
    });
const updateOrganizationPublicSettings = joi.object({
    displayName: displayNameValidation,
    email: optionalEmailValidation,
    description: descriptionValidation,
    privacyOptions: privacyOptionsValidation,
    locationOptions: locationOptionsValidation,
    socialAccounts: socialAccountsValidation
}).required();
const changeOrganizationName = joi.object({
    name: nameValidation
}).required();
const orgSettingsUpdateForm = updateOrganizationPublicSettings.append({
    socialAccounts: socialAccountsFormValidation,
    avatarColor: emptyStringValidation,
    logoUrl: emptyStringValidation,
    name: nameValidation
});
const updateOrgMembershipSettings = joi.object({
    openMembership: joi.boolean().required(),
    domains: joi.array().items(joi.string().pattern(ORGANIZATION_DOMAIN_VALIDATOR.pattern.value)).messages({
        'string.min': ORGANIZATION_DOMAIN_VALIDATOR.minLength.message,
        'string.max': ORGANIZATION_DOMAIN_VALIDATOR.maxLength.message,
        'string.pattern.base': ORGANIZATION_DOMAIN_VALIDATOR.pattern.message
    })
});
export { changeOrganizationName, inviteMemberBaseSchema, orgSettingsDeleteForm, orgSettingsUpdateForm, socialAccountsFormValidation, updateOrgMembershipSettings, updateOrganizationPublicSettings };
